<ul class="breadcrumb breadcrumb-page">
  <li><a href="#">{{'app.Home' | translate}}</a></li>
  <li class="active">{{'mainMenu.requests' | translate}}</li>
</ul>

<div class="page-header">
  <div class="row">
    <h1 class="col-xs-12 col-sm-4 text-center text-left-sm"><img [src]="logo" class="img-icon" />&nbsp;&nbsp;{{'mainMenu.requests' | translate}}</h1>
  </div>
</div>

<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'app.searchTitle' | translate}}</span>
  </div>

  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-6">
          <!--<input type="text"
                 name="name"
                 placeholder="{{'app.search' |translate}}"
                 autocomplete="off"
                 class="form-control" />-->
        </div>
        <div class="col-sm-3 margin-top-10 cursor-pointer" (click)="openFilterModal()">
          <span class="margin-right-7 filter-span">{{'app.Filter' | translate}}</span>
          <i class="fa fa-filter" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="panel panel-success widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'app.searchResult' | translate}}</span>
  </div>
  <div class="panel-body padding-sm-hr" id="visitsTbl">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-12">
          <p-table #dt [value]="hcps" [responsive]="true" sortMode="multiple" [paginator]="true" [rows]="pageSize" [totalRecords]="totalItems" [lazy]="true" (onLazyLoad)="pageChanged($event)">
            <ng-template pTemplate="header">
              <tr>
                <!--<th width="5%">#</th>-->
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" class="table-edit">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>

              </tr>
              <tr *ngIf="displayMode==1">
                <td colspan="3" class="container text-center">

                  <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>

                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-visit>
              <tr *ngIf="hcps.length>0 && displayMode==2">
                <td> {{ visit.id }} </td>
                <td>
                  {{ visit.name }}
                </td>
                <td *ngIf="showEnglishName">
                  {{ visit.englishName }}
                </td>
                <td> {{ visit.createdByName }} </td>
                <td>{{ visit.creationDate | date :'dd/MM/yyyy'}}</td>

                <td *ngIf="visit.addingStatus!=2 &&visit.addingStatus!=3&&visit.addingStatus!=4"></td>
                <td *ngIf="visit.addingStatus==2 || visit.addingStatus==3||visit.addingStatus==4">{{getPlanStatusName(visit.addingStatus)}}</td>

                <td> {{ visit.approvalLevelStatus }} </td>
                <td> {{ visit.approvalLevel }} </td>

                <td *ngIf="visit.addingStatus==3 || visit.addingStatus==4 || visit.approvalLevel>0">{{ visit.lastModificationDate | date :'dd/MM/yyyy'}}</td>
                <td *ngIf="visit.addingStatus==3 || visit.addingStatus==4 || visit.approvalLevel>0"> {{ visit.lastModifiedByName }} </td>

                <td *ngIf="visit.addingStatus!=3&&visit.addingStatus!=4 && (!visit.approvalLevel || visit.approvalLevel==0)"></td>
                <td *ngIf="visit.addingStatus!=3&&visit.addingStatus!=4 && (!visit.approvalLevel || visit.approvalLevel==0)"></td>

              </tr>
              <tr *ngIf="hcps.length==0 && displayMode==2">
                <td colspan="5">{{'app.NoDataFound' | translate}}</td>
              </tr>

              <tr *ngIf="displayMode==3">
                <td colspan="7">
                  <div class="alert alert-danger alert-dark">
                    <button type="button" class="close" data-dismiss="alert">×</button>
                    {{'app.ServerError' |translate}}.
                  </div>
                </td>

              </tr>
            </ng-template>
          </p-table>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-sm-6">
  </div>
  <div class="col-sm-2 cursor-pointer left-31">

  </div>
  <div class="col-sm-2 cursor-pointer left-19" (click)="downloadCSV()">
    <span class="margin-right-7 edit-profile-span">{{'reports.excel' | translate}}</span>
    <i class="fa fa-download" aria-hidden="true"></i>
  </div>
  <div class="col-sm-2 cursor-pointer left-8">

  </div>
</div>



<div class="modal fade" bsModal #filterModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="filter-title">{{'app.Filter'  | translate}}</h1>
      </div>
      <div class="row panel-body padding-sm-hr padding-top-0 padding-bottom-0">
        <div class="row">
          <div class="col-sm-6">
            <label class="control-label">{{'pageHeader.DateFrom' | translate}} </label>
            <div class="input-group date">
              <input type="text"
                     name="startDate"
                     #startDate="ngModel"
                     [(ngModel)]="search.startDate"
                     required="required"
                     #dpYMD="bsDatepicker"
                     bsDatepicker
                     [bsConfig]="{dateInputFormat: 'YYYY-MM-DD' }" class="form-control" autocomplete="off">
              <span class="input-group-btn date-label">
                <button class="btn date-btn" (click)="dpYMD.toggle()" type="button"><i class="fa fa-calendar"></i></button>
              </span>


            </div>
          </div>
          <div class="col-sm-6">
            <label class="control-label">{{'pageHeader.DateTo' | translate}}</label>
            <div class="input-group date">
              <input type="text"
                     name="endDate"
                     #endDate="ngModel"
                     [(ngModel)]="search.endDate"
                     required="required"
                     #dpYMD1="bsDatepicker"
                     bsDatepicker
                     [bsConfig]="{dateInputFormat: 'YYYY-MM-DD' }" class="form-control" autocomplete="off">
              <span class="input-group-btn date-label">
                <button class="btn date-btn" (click)="dpYMD1.toggle()" type="button"><i class="fa fa-calendar"></i></button>
              </span>

            </div>
          </div>
          <div class="col-sm-6">
            <label class="control-label">{{'reports.users' | translate}} </label>
            <span class="ui-fluid">
              <p-dropdown [options]="users"
                          name="visitAssistants" #visitAssistants="ngModel"
                          styleClass="wid100"
                          placeholder="User"
                          emptyFilterMessage="No results found"
                          showClear="true"
                          [(ngModel)]="search.user"
                          [virtualScroll]="true" itemSize="10"
                          [filter]="true" optionLabel="fullName"></p-dropdown>

            </span>
          </div>
          <div class="col-sm-6">
            <label class="control-label">{{'app.name' | translate}} </label>
            <input type="text"
                   name="name"
                   [(ngModel)]="search.searchText"
                   placeholder="{{'app.name' |translate}}"
                   #name="ngModel"
                   autocomplete="off"
                   class="form-control" />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <label class="control-label">{{'Status' | translate}} </label>
            <span class="ui-fluid">
              <p-dropdown [options]="statuses"
                          name="sta" #sta="ngModel"
                          styleClass="wid100"
                          placeholder="Status"
                          emptyFilterMessage="No results found"
                          showClear="true"
                          [(ngModel)]="search.status"
                          [virtualScroll]="true" itemSize="10"
                          [filter]="true" optionLabel="name"></p-dropdown>
            </span>
          </div>

        </div>
        <div class="panel-footer margin-left-20 margin-top-20">
          <button type="button" (click)="hideFilterModal()" class="btn btn-cancel">{{'app.cancel' | translate}}</button>
          <button type="button" class="btn btn-save" (click)="searchFilterModal()">{{'Search' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
